import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { PlotData } from "./models/ThermoModels";



export default class ThermoWidgetVuexModule extends AbacoVuexModule {
    @State() selectedThermo!: number;

    @State() toPlotData!: PlotData | null;
    @State() loadingPlot!: boolean;

    @State() calculationId!: number;

    @State({default: false}) thermoToAnalyzeImageLoading!: boolean;
    @State({default: false}) thermoToAnalyzeMetadataLoading!: boolean;

    @State() plotHoverCoords!: number[]
}
